import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCrossSmall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCrossSmall"><Path fillRule="evenodd" clipRule="evenodd" d="M8.00001 6.23242L12 10.2324L16 6.23242L17.7678 8.00019L13.7678 12.0002L17.7678 16.0002L16 17.768L12 13.768L8.00001 17.768L6.23224 16.0002L10.2322 12.0002L6.23224 8.00019L8.00001 6.23242Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCrossSmall;
